import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/SignUpSlice';
// import { SignUpEmailVerificationResponse } from 'Types/ResponseBodies';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.signUp || initialState;

export const selectResponse = createSelector(
  [selectDomain],
  (state) => state.emailForVerificationResponse,
);

export const selectTellMeMoreResponse = createSelector(
  [selectDomain],
  (state) => state.tellMeMoreResponse,
);

export const selectVerificationEmail = createSelector(
  [selectDomain],
  (state) => state.emailForVerification,
);

export const selectSignUpFormResponse = createSelector(
  [selectDomain],
  (state) => state.SignUpFormResponse,
);
export const selectError = createSelector([selectDomain], (state) => state.error);

export const selectVerificationCodeData = createSelector(
  [selectDomain],
  (state) => state.submitVerificationCode.data,
);

export const selectVerificationCodeEmailData = createSelector(
  [selectDomain],
  (state) => state.sendVerificationCodeEmail.data,
);

export const selectVerificationCodeLoading = createSelector(
  [selectDomain],
  (state) => state.submitVerificationCode.loading,
);

export const selectVerificationCodeEmailLoading = createSelector(
  [selectDomain],
  (state) => state.sendVerificationCodeEmail.loading,
);

export const selectVerificationCodeLoaded = createSelector(
  [selectDomain],
  (state) => state.submitVerificationCode.loaded,
);

export const selectVerificationCodeEmailLoaded = createSelector(
  [selectDomain],
  (state) => state.sendVerificationCodeEmail.loaded,
);
